/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_6cebcd68"]'><cube-button outline primary>outline - primary</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_6cebcd68"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_6cebcd68"}
  /** script content **/
  require("./btn-outline-primary.mpx.js?isComponent&outputPath=components%2Fbtn-outline-primary6cebcd68%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-outline-primary.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-outline-primary6cebcd68%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_6cebcd68"],
    ctorType: "component",
    outputPath: "components/btn-outline-primary6cebcd68/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>